export function normalizeRole(role) {
  return String(role || "authenticated").toLowerCase().replace(/\s+/g, "_");
}

export function roleLabel(role) {
  const labels = {
    authenticated: "Usuario autenticado",
    admin: "Administrador de tenant",
    tenant_manager: "Tenant manager",
    superadmin: "Superadmin",
  };
  return labels[normalizeRole(role)] || normalizeRole(role);
}

export function isSystemRole(role) {
  return ["superadmin", "admin", "tenant_manager", "authenticated"].includes(normalizeRole(role));
}

export function canOpenFeature(role, feature) {
  const normalized = normalizeRole(role);
  if (normalized === "superadmin") return ["users", "roles"].includes(feature);
  if (normalized === "admin") return ["users", "roles"].includes(feature);
  if (normalized === "tenant_manager") return ["users", "roles"].includes(feature);
  return false;
}

export function canManageRole(actorRole, targetRole) {
  return false; // Las jerarquías funcionales se resuelven con permisos y scopes de cada feature.
}

export function canUpdateUser(actor, targetUser, nextRole, scope) {
  if (!actor || !targetUser) return false;
  if (["superadmin", "admin", "tenant_manager"].includes(normalizeRole(targetUser.role_slug))) return false;
  return scope === "global" ? normalizeRole(actor.role) === "superadmin" : false;
}

export function canDeleteUser(actor, targetUser, firstAdminId) {
  if (!actor || !targetUser || Number(targetUser.id) === Number(firstAdminId)) return false;
  if (["superadmin", "admin", "tenant_manager"].includes(normalizeRole(targetUser.role_slug))) return false;
  return normalizeRole(actor.role) === "admin";
}

export function filterUsersForScope(users, actor, scope) {
  if (scope === "global") return normalizeRole(actor?.role) === "superadmin" ? users : [];
  return users;
}

export function firstAdminId(users) {
  return users.find((user) => normalizeRole(user.role_slug) === "superadmin")?.id;
}

export function isSelf(actor, user) {
  return actor?.user_id && Number(actor.user_id) === Number(user?.id);
}

export function allowedRoleOptions(actorRole, roles = [], scope = "tenant") {
  const normalized = normalizeRole(actorRole);
  return roles.filter((role) => {
    if (scope === "global") return normalized === "superadmin" && normalizeRole(role.slug) === "superadmin";
    return normalized === "admin" && !["superadmin", "admin", "tenant_manager"].includes(normalizeRole(role.slug));
  });
}
